var socketNum = 0;
var websocket = null;
import {
  DELOP_getOsInfoFn,
  DELOP_getExploreName,
  hex_md5,
  DELOP_SEVISE,
  DELOP_getSourse,
  getCookie,
  setCookie
} from '@/utils/md5';
import confg from '@/fetch/config';
import { EncryptRSA, encryptAES } from '@/utils/encrypt.js'
import { saveCollectVisitorInfo } from '@/services/chat.js';
const {
  socketUrl
} = confg;
var webToken = '';
var once_link = true;
var isShangbao = true;
var closeSocketFlag = true;
var nowHref = window.location.href;
var nowTitle = document.title;
var conversationId_one = '';
// 首次链接上报false,重新链接true
var websocketReset = false;
var successFlag = false
// 根据companyId, timestamp, salt 生成token
function generateToken(id, timestamp) {
  let salt = "Yuuxin";
  return hex_md5(encodeURIComponent(id + String(timestamp) + salt)).toUpperCase();
}

function getInitParams(params) {
  const {
    companyId = '', groupConversationId, conversationId, childChannelId, visitSign, visitName, webType = 'web', xst = ''
  } = params;
  let yunduoIdKey = 'ocr_yunduoId_' + childChannelId
  let yunduoId = getCookie(yunduoIdKey)
  var getOsInfo = DELOP_getOsInfoFn();
  var browerNameInfo = DELOP_getExploreName();
  var sourceInfo = DELOP_getSourse(params.SR);
  var timestamp = new Date().getTime();
  //if (!webToken) {
    webToken = generateToken(companyId, timestamp);
  //}
  let pars = {
    yunduoId,
    type: conversationId ? 'IM_CONVERSATION_REQ' : 'NETTY_AUTH_REQ',
    date: timestamp,
    token: webToken,
    module: 'im',
    platform: webType == 'web' ? 2 : 3,
    deviceId: groupConversationId,
    companyId: companyId,
    visitSign: visitSign,
    visitorName: decodeURIComponent(visitName),
    channelId: webType == 'web' ? 1 : 2,
    childChannelId: childChannelId,
    conversationId: conversationId,
    systemOS: getOsInfo.name,
    browser: browerNameInfo,
    groupConversationId: groupConversationId,
    title: conversationId ? nowTitle : params.CT || '',
    currentURL: conversationId ? nowHref : params.CH || (sourceInfo.url || nowHref),
    device: DELOP_SEVISE(),
    source: xst ? '百度-付费链接' : sourceInfo.source,
    sourceKeyword: sourceInfo.keyword,
    fromPageTitle: '',
    fromPageURL: sourceInfo.url,
    conversationFlag: conversationId ? 1 : 0,
    landingFlag: (once_link || !conversationId) ? 1 : 0, //是否是着陆页
    xst: xst,
    from: xst ? 1 : sourceInfo.nums
  };
  if (once_link) {
    once_link = false;
  }
  return pars;
}

export function startWebSocket(params) {
  // http上报
// 上报会话信息
  let rsaKey = [];
  for (var i = 0; i < 16; i++) {
    rsaKey.push(Math.floor(Math.random() * 10));
  }
  let aesValue = JSON.stringify(getInitParams({...params}));

  if (websocket) {
    if (params.conversationId) {
      if (conversationId_one != params.conversationId) {
        conversationId_one = params.conversationId;
        var InitParams = getInitParams({...params});
        console.log('InitParams', InitParams, params);
        InitParams.companyId = ''
        websocket.send(JSON.stringify(InitParams));
        if (isShangbao) {
          isShangbao = false
          saveCollectVisitorInfo({
            rsaKey: EncryptRSA(rsaKey.join('')),
            aesValue: encryptAES(aesValue, rsaKey.join(''))
          }).then(res => {
            isShangbao = false;
            console.log(`socket上报会话信息`, res.data);
          })
        }
      }
    }
  } else {
    //避免重复连接
    var lockReconnect = false,
      tt;
    /**
     * websocket启动
     */
    function createDeployWebSocket() {
      try {
        if ('WebSocket' in window) {
          console.log('socketUrl333', socketUrl)
          websocket = new WebSocket(socketUrl);
        } else if ('MozWebSocket' in window) {
          websocket = new MozWebSocket(socketUrl);
        } else {
          websocket = new SockJS(socketUrl);
        }
        console.log('socketUrl333', socketUrl)
        init();
      } catch (e) {
        reconnect();
      }
    }
    // 连接成功建立的回调方法
    function init() {
      websocket.onopen = function (event) {
        console.log("WebSocket:已连接");
        successFlag = true
        var InitParams = getInitParams({
          ...params,
          conversationId: ''
        });
        // 首次链接添加参数
        InitParams.reset = websocketReset;
        console.log("WebSocket:onopen ==>", InitParams);
        websocket.send(JSON.stringify(InitParams));
        //心跳检测重置
        heartCheck.reset().start();
      };
      //接收到消息的回调方法
      websocket.onmessage = function (event) {
        // var message = event.data;
        // console.log("WebSocket:收到一条消息", event.data);
      };
      //连接发生错误的回调方法
      websocket.onerror = function (event) {
        console.log("WebSocket:发生错误");
        var InitParams = getInitParams();
        let onlyKey = `${InitParams.childChannelId}_${InitParams.groupConversationId}`;
        let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
        console.log('conversationId', conversationId)
        if (!conversationId && closeSocketFlag) {
          localStorage.setItem('disabled_socket', 1)
          websocket.close()
          websocket = null
        }
        heartCheck.reset(); //心跳检测
        reconnect();
      };
      //连接关闭的回调方法
      websocket.onclose = function (event) {
        console.log("WebSocket:已关闭");
        var InitParams = getInitParams();
        let onlyKey = `${InitParams.childChannelId}_${InitParams.groupConversationId}`;
        let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
        console.log('conversationId', conversationId)
        if (!conversationId && closeSocketFlag) {
          localStorage.setItem('disabled_socket', 1)
          websocket.close()
          websocket = null
        }
        webToken = '';
        heartCheck.reset(); //心跳检测
        reconnect();
      };
    }
    /**
     * websocket重连
     */
    function reconnect() {
      let closeFlag = localStorage.getItem('disabled_socket')
      if (+closeFlag === 1) return false
      if (lockReconnect) {
        return;
      }
      // if (socketNum > 10) { //重连超过10次
      //   return;
      // }
      lockReconnect = true;
      // 重新链接
      if (successFlag) websocketReset = true;
      tt && clearTimeout(tt);
      tt = setTimeout(function () {
        console.log('重连中...');
        lockReconnect = false;
        socketNum++;
        createDeployWebSocket();
      }, 2000);
    }
    /**
     * websocket心跳检测
     */
    var heartCheck = {
      timeout: 8000,
      timeoutObj: null,
      reset: function () {
        clearTimeout(this.timeoutObj);
        return this;
      },
      start: function () {
        var that = this;
        let closeFlag = localStorage.getItem('disabled_socket')
        if (+closeFlag === 1) return false
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.timeoutObj = setTimeout(function () {
          let timestamp = new Date().getTime();
          if (!webToken) {
            webToken = generateToken(params.companyId, timestamp);
          }
          var sendParams = {
            type: 'NETTY_HEART_BEAT_REQ',
            date: timestamp,
            companyId: params.companyId,
            token: webToken,
            module: 'im',
            platform: params.webType == 'web' ? 'WEB' : 'H5',
            deviceId: params.groupConversationId
          };
          websocket.send(JSON.stringify(sendParams));
          that.start();
          // console.log('ping', '心跳发送send');
        }, this.timeout)
      }
    };
    createDeployWebSocket();
  }
}



// WEBPACK FOOTER //
// ./src/utils/socket.js